import { tedMediaArray } from './tedMedia'
import { tedBio } from './tedBios'
import { stellaReviewerReviewTinder, robinReviewerReviewHinge, zoeyReviewerReviewBumble } from './tedReviewerReviews'
import { stellaReviewerProfile, robinReviewerProfile, zoeyReviewerProfile } from './tedReviewers'

export const robinProfileReviewHinge = {
  _id: 'robinProfileReviewHingeId',
  userId: 'tedUserId',
  userEmail: 'ted@email.com',
  datingProfileId: 'tedDatingProfileHingeId',
  reviewerProfileId: 'robinReviewerProfileId',
  reviewerEmail: 'robin@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: tedMediaArray[12]._id,
      mediaItemURL: tedMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[12].type,
      caption: tedMediaArray[12].captions[0],
      subcaption: tedMediaArray[12].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[11]._id,
      mediaItemURL: tedMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[11].type,
      caption: tedMediaArray[11].captions[1],
      subcaption: tedMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: tedMediaArray[10]._id,
      mediaItemURL: tedMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[10].type,
      caption: tedMediaArray[10].captions[0],
      subcaption: tedMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[9]._id,
      mediaItemURL: tedMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[9].type,
      caption: tedMediaArray[9].captions[2],
      subcaption: tedMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[7]._id,
      mediaItemURL: tedMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[7].type,
      caption: tedMediaArray[7].captions[2],
      subcaption: tedMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[3]._id,
      mediaItemURL: tedMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[3].type,
      caption: tedMediaArray[3].captions[0],
      subcaption: tedMediaArray[3].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Great photo, love the smile. Do you live at your parents' house? Just kidding. The background seems super domestic though`,
      verdict: 'Yes',
    },
    {
      feedback: `You look like a dork who will pull a quarter out of my ear and think you're clever`,
      verdict: 'No',
    },
    {
      feedback: `This is more like it! LOL! Let's go to a sports bar and watch a hockey game!`,
      verdict: 'Very',
    },
    {
      feedback: `You look like a pretentious prick, but at least you call yourself out on that in the caption`,
      verdict: 'Yes',
    },
    {
      feedback: `Hard no! So bland. There are plenty of pieces of cardboard to go out with. Show some personality`,
      verdict: 'No',
    },
    {
      feedback: `Here we go! Another gem! Looks like you've watched all of the Lord of the Rings movies in a row. I'll join for the next one, we'll roll a joint and get into it`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: tedBio._id,
    vitalInfo: { ...tedBio.vitalInfo },
    prompts: [
      { ...tedBio.prompts[0] },
      { ...tedBio.prompts[1] },
      { ...tedBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You seem well-educated and like you have a good profession. I like that we both enjoy drinking and weed.`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: ``,
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Yellow umbrella? Terrible joke if it's a joke. And if you're a 'hopeless romantic' that's even worse`,
        verdict: 'No', 
      },
      {
        feedback: `All super generic, but yeah I like those things too. But what's unique to *you*? Why would I date you and not the thousand other guys who like coffee?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `I prefer if I'm the girl in the relationship.`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `You're professionally successful and well educated and oftentimes quite dorky, but you have a fun side too.`,
    good: `I like that you drink with friends and joke with your roommates.`,
    notGood: `You seem like a bit of sterile, pedantic dork in a lot of the photos. Not sure if you have any edge to you.`,
    verdict: `You are not at all showcasing your most attractive self. Lovable dweeb just isn't what many women go for. I think replacing the dweeby elements of your profile with more fun images and prompts would help you quite a bit.`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...robinReviewerReviewHinge },
  reviewerProfile: { ...robinReviewerProfile },
  bioItems: { ...tedBio },
  mediaItems: [ ...tedMediaArray ],
}

export const zoeyProfileReviewBumble = {
  _id: 'zoeyProfileReviewHingeId',
  userId: 'tedUserId',
  userEmail: 'ted@email.com',
  datingProfileId: 'tedDatingProfileBumbleId',
  reviewerProfileId: 'zoeyReviewerProfileId',
  reviewerEmail: 'zoey@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: tedMediaArray[10]._id,
      mediaItemURL: tedMediaArray[10].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[10].type,
      caption: tedMediaArray[10].captions[0],
      subcaption: tedMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[11]._id,
      mediaItemURL: tedMediaArray[11].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[11].type,
      caption: tedMediaArray[11].captions[1],
      subcaption: tedMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: tedMediaArray[3]._id,
      mediaItemURL: tedMediaArray[3].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[3].type,
      caption: tedMediaArray[3].captions[0],
      subcaption: tedMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[9]._id,
      mediaItemURL: tedMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[9].type,
      caption: tedMediaArray[9].captions[2],
      subcaption: tedMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[12]._id,
      mediaItemURL: tedMediaArray[12].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[12].type,
      caption: tedMediaArray[12].captions[0],
      subcaption: tedMediaArray[12].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[7]._id,
      mediaItemURL: tedMediaArray[7].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[7].type,
      caption: tedMediaArray[7].captions[2],
      subcaption: tedMediaArray[7].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look like you're about to fart and burp at the same time.`,
      verdict: 'No',
    },
    {
      feedback: `OK, kind of fun, clearly you're trying to make a joke. You look super dweeby though, so it looks like the joke probably wasn't funny.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look entranced by something. Or stoned... which is right up my alley. Let's roll a joint.`,
      verdict: 'Yes',
    },
    {
      feedback: `In this photo you're the most pretentious yuppy I've ever laid eyes on. It is kind of cute though.`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is your best photo. You look like you're in your element and really enjoying yourself.`,
      verdict: 'Yes',
    },
    {
      feedback: `So bland! No!`,
      verdict: 'No',
    }
  ],
  bio: {
    bioItemsId: tedBio._id,
    vitalInfo: { ...tedBio.vitalInfo },
    prompts: [
      { ...tedBio.prompts[0] },
      { ...tedBio.prompts[1] },
      { ...tedBio.prompts[2] }
    ],
    aboutMe: tedBio.aboutMe[0],
    hobbies: [tedBio.hobbies[0], tedBio.hobbies[1], tedBio.hobbies[2], tedBio.hobbies[3], tedBio.hobbies[4] ],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You're well educated, and I like that we have the same relationships with drinking and weed.`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: `OK, this is cute. Dweeby but cute.`,
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `This doesn't land.`,
        verdict: 'No', 
      },
      {
        feedback: `But what really gets you going? Do you do action sports or participate in protests? This is so generic`,
        verdict: 'No', 
      },
      {
        feedback: `Yikes. Go to Nantucket, you'll find someone there who would eagerly debate this topic with you.`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `You're obviously well eductated and professionally successful, but you're also a bit of a pretentious dweeb.`,
    good: `The casual photos where you're smiling, drinking, or on your couch are good.`,
    notGood: `All of the pretentious stuff, especially the prompts and responses.`,
    verdict: `No way! Show me more personality! You look like either a dork, a pretentious prick, or both. I'm sure your not those things, but that's the vibe your profile displays`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...zoeyReviewerReviewBumble },
  reviewerProfile: { ...zoeyReviewerProfile },
  bioItems: { ...tedBio },
  mediaItems: [ ...tedMediaArray ],
}

export const stellaProfileReviewTinder = {
  _id: 'stellaProfileReviewTinderId',
  userId: 'tedUserId',
  userEmail: 'ted@email.com',
  datingProfileId: 'tedDatingProfileTinderId',
  reviewerProfileId: 'stellaReviewerProfileId',
  reviewerEmail: 'stella@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: tedMediaArray[12]._id,
      mediaItemURL: tedMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[12].type,
      caption: tedMediaArray[12].captions[0],
      subcaption: tedMediaArray[12].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[11]._id,
      mediaItemURL: tedMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[11].type,
      caption: tedMediaArray[11].captions[1],
      subcaption: tedMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: tedMediaArray[10]._id,
      mediaItemURL: tedMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[10].type,
      caption: tedMediaArray[10].captions[0],
      subcaption: tedMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[9]._id,
      mediaItemURL: tedMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[9].type,
      caption: tedMediaArray[9].captions[2],
      subcaption: tedMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[7]._id,
      mediaItemURL: tedMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[7].type,
      caption: tedMediaArray[7].captions[2],
      subcaption: tedMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[3]._id,
      mediaItemURL: tedMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[3].type,
      caption: tedMediaArray[3].captions[0],
      subcaption: tedMediaArray[3].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look super relaxed here, like you're laughing at a joke with your roommate. I'm a huge fan of the casual vibe, but it's hard to tell if your posture is OK, so I hope you're standing in some of the following photos`,
      verdict: 'Yes',
    },
    {
      feedback: `Love the outfit, very smart and academic. Obviously you're a social guy who likes to joke around and laugh`,
      verdict: 'Yes',
    },
    {
      feedback: `Not gonna sugarcoat it — you look like a total alcoholic slob here. I wasn't even into frat guys in college. Definitely change this`,
      verdict: 'No',
    },
    {
      feedback: `A very classy setting, but your face is a strange. You save it with caption and subcaption though — I like that you can laugh at yourself`,
      verdict: 'Yes',
    },
    {
      feedback: `This is really bland, and I wish you were smiling. Cute, well-dressed, but sterile isn't anyone's dream man.`,
      verdict: 'No',
    },
    {
      feedback: `OK, this is a funny photo. You look like you've been watching TV for 48 straight hours. I don't know why it's funny, but I like it. I'm not sure others will like it though.`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: tedBio._id,
    vitalInfo: { ...tedBio.vitalInfo },
    prompts: [
      { ...tedBio.prompts[0] },
      { ...tedBio.prompts[1] },
      { ...tedBio.prompts[2] }
    ],
    aboutMe: tedBio.aboutMe[0],
    hobbies: [tedBio.hobbies[0], tedBio.hobbies[1], tedBio.hobbies[2], tedBio.hobbies[3], tedBio.hobbies[4] ],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You're clearly well educated and professionally successful. I'm nervous you might drink too much, and I don't smoke weed, so I hope it's not a habit for you`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: `OK, this is cute. Dweeby but cute.`,
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Umm... I don't get the reference, and I've never had a yellow umbrella, so it doesn't sound like you're nostalgic for me. Hard pass.`,
        verdict: 'No', 
      },
      {
        feedback: `I love all three. You seem like a social guy who appreciates simple things, and you have a hint of nostalgia to you`,
        verdict: 'Very', 
      },
      {
        feedback: `Are you gay? (Mauve)`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `You seem like a social guy who appreciates simple things, and you have a hint of nostalgia to you. You also seem intelligent and professionally successful`,
    good: `I like that you're a casual person, and you have a nice smile. You also seem successful and well educated`,
    notGood: `Your nostalgic side doesn't really connect with me, and you've made a few jokes, particularly about the yellow umbrella that didn't land. Also, I worry that you drink too much and might have a weed habit.`,
    verdict: `In real life you might be a catch, but your dating profile isn't optimized to showcase your best self as it currently is. Too many serious and goofy pics. It's hard to imagine casual interaction with you. Some lighthearted images in non-bar settings where you're smiling in a casual way would help.`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...stellaReviewerReviewTinder },
  reviewerProfile: { ...stellaReviewerProfile },
  bioItems: { ...tedBio },
  mediaItems: [ ...tedMediaArray ],
}